import React from "react";
import { useDispatch, useSelector } from "react-redux";

// REDUX
//APP COMPONENTS
import { setShowOperationDataModal } from "../../store/actions/operationDataSlice";
import OperationDataModal from "../xRay/OperationDataModal";
// MATERIAL UI

export default function OperationDataManager() {
  const dispatch = useDispatch();

  const showOperationDataModal = useSelector(
    (state) => state.operationData.showOperationDataModal
  );

  const handleShowOperationData = () => {
    dispatch(setShowOperationDataModal(!showOperationDataModal));
  };

  return (
    <>
      <OperationDataModal
        show={showOperationDataModal}
        closeModal={handleShowOperationData}
      />
    </>
  );
}
